import { ForgotPasswordComponent } from "./forgot-password.component";
import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { NgxSpinnerModule } from "ngx-spinner";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule } from "@angular/material/input";
import { CommonModule } from "@angular/common";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ForgotPasswordRoutingModule } from "./forgot-password-routing.component";
import { AuthInterceptorProvider } from "../services/token/token-interceptor.service";

@NgModule({
    declarations: [ 
        ForgotPasswordComponent
    ],
    imports: [
        ForgotPasswordRoutingModule,
        CommonModule,
        FormsModule,
        MatInputModule,
        NgxSpinnerModule,
        ReactiveFormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        HttpClientModule
    ],
    providers: [
        AuthInterceptorProvider,
    ]
})
export class ForgotPasswordModule { }

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}